<template>
  <v-dialog
    :model-value="props.showModal"
    content-class="modal-promocode__container"
    @update:model-value="props.handleToggle"
    absolute
    attach=".app-template"
    :scrim="false"
  >
    <div class="modal">
      <div class="modal-background" @click="props.handleToggle" />
      <div class="modal-body">
        <div v-if="title" class="modal-body__title">{{ props.title }}</div>
        <div v-if="description" class="modal-body__desc">{{ props.description }}</div>
        <div class="modal-body__buttons">
          <slot name="button" />
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script lang="ts" setup>
import { PropType } from 'vue';

import { TFunction } from '@/types/TFunction';

const props = defineProps({
  showModal: {
    type: Boolean as PropType<boolean>,
    required: true,
  },
  title: {
    type: String as PropType<string>,
    required: false,
  },
  description: {
    type: String as PropType<string>,
    required: false,
  },
  handleToggle: {
    type: Function as PropType<TFunction>,
    required: true,
  },
});
</script>

<style lang="scss" src="./AiModal.scss"></style>
